module.exports = __webpack_public_path__ + "static/img/doctor_icon.34f1a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointment/doctor_icon.png
// module id = CCUz
// module chunks = 1